import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './router'
import './assets/main.css'
import ui from '@nuxt/ui/vue-plugin'
import ClientOnly from './components/utils/ClientOnly.vue'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(ui, {
  ui: {
    modal: { slots: { overlay: 'z-[2147483646]', content: 'z-[2147483647]' } },
    slideover: { slots: { overlay: 'z-[2147483646]', content: 'z-[2147483647]' } },
    drawer: { slots: { overlay: 'z-[2147483646]', content: 'z-[2147483647]' } },
  },
})
app.component('ClientOnly', ClientOnly)

app.mount('#app')
